module.exports = function (app) {
    app.directive('inputField', function ($timeout, $rootScope) {
        return {
            templateUrl: '_directives/inputField.employerTemplate.html/directives/employee/inputField',
            scope: {
                inputSearchHeading: '@',
                inputPlaceHolder:'@',
                inputField: '=inputField'
            },
            link: function(scope, elem, attrs) {
            },
            controller: ['$scope', function($scope){
                //$scope.searchData = $scope.searchData || {};
               //changes for RF1240502 . Member id patter check to do alpha numeric only. Length check is happening in HTML
               $scope.memberIdPattern = /^[a-zA-Z0-9]*$/;




                // $scope.clearListId = function () {
                //     delete $scope.searchData.listId;
                // };
            }]

        };
    });
};
